import { types } from 'mobx-state-tree';
import { RequestStateModel } from 'store/models/general-models';

export const Statuses = types.model('QrCodeAuthStatuses', {
  generateQrCode: types.optional(RequestStateModel, {}),
  qrAuthStage: types.optional(RequestStateModel, {}),
});

export const GeneratedQrCode = types.model('GeneratedQrCode', {
  login_session_id: types.optional(types.string, ''),
  qr_image_base64: types.optional(types.string, ''),
});
